<template>
  <v-container v-scroll="handleScroll" fluid class="portfolio py-5" style="max-width : 1360px">
  <w-dialog v-if="showDialog" :open.sync="showDialog" :projektNr="projektNr"/>

    <v-row justify="center" >
      <!-- HERO: logo + opis -->
<!--      <v-col cols="12" md="10" class="mb-10">
        <v-row class="align-center ">
          <v-col cols="12" md="4" class="text-center text-md-left mb-6 mb-md-0">
            <v-img
              alt="Logo"
              class="portfolio__logo  mx-md-0"
              src="images/logo.jpg"
              contain
              style="min-width : 100%"
            />
          </v-col>

          <v-col cols="12" md="8" class="text-end d-flex justify-center align-end flex-column">
            <div class="text-h4 text-md-h3 font-weight-bold ">
              Portfolio
            </div>

          </v-col>
        </v-row>
      </v-col>-->

      <!-- KENNTNISSE + FOTO -->
<v-col ref="section0" cols="12" md="10" class="mb-12">
  <v-row>
<!--   tab {{tab}} -->
          <!-- więcej tekstu, mniej zdjęcia: 8 / 4 -->
      <v-col cols="12" md="8">
        <p class="body-1  portfolio__lead mt-3" style=" " :class="$vuetify.breakpoint.xsOnly ? 'text-justify' : 'text-left'">
          Erfahrene Architektin mit umfassender Expertise in der Planung und
          Realisierung anspruchsvoller Hochbauprojekte. Besonderer Fokus auf
          nachhaltigen, funktionalen und gestalterisch hochwertigen Lösungen.
          Routiniert in BIM-gestützten Planungsprozessen, interdisziplinärer
          Zusammenarbeit und ressourcenschonenden Bauweisen. Fundierte Kenntnisse
          der HOAI Leistungsphasen 1–8 sowie langjährige Erfahrung in Bauleitung
          und Projektkoordination. Sicherer Umgang mit moderner CAD-Software
          (Revit, AutoCAD, ArchiCAD). Fließend in Deutsch, Englisch und Polnisch.
        </p>

        <div v-if="!$vuetify.breakpoint.smAndDown">
        <div class="title font-weight-bold mb-3 mt-7">
          Kenntnisse &amp; Fähigkeiten
        </div>

        <ul class="portfolio__list body-1">
          <li class="portfolio__list-item">
            <strong>Architektonische Kompetenz:</strong>
            BIM-basierte Planung, nachhaltiges Bauen, HOAI Lph 1–8,
            Wettbewerbsplanung, Bauleitung
          </li>

          <li class="portfolio__list-item">
            <strong>Projektmanagement:</strong>
            Strukturierte Koordination, Termin- und Qualitätskontrolle,
            Bauüberwachung
          </li>

          <li class="portfolio__list-item">
            <strong>Persönliche Stärken:</strong>
            Zielorientierte Arbeitsweise, hohe Belastbarkeit unter Zeitdruck,
            Teamführung, interdisziplinäre Kommunikation, souveräne Präsentationen
            und praxisorientierte Problemlösung
          </li>
        </ul>
        </div>


      </v-col>

      <v-col  cols="12" md="4" class="text-center">
        <v-img
          alt="Portrait"
          class="portfolio__portrait mx-auto"
          src="images/Foto1_MoniaE.jpg"
          :aspect-ratio="3/4"
          fit
        />
      </v-col>
      <div v-if="$vuetify.breakpoint.smAndDown" class="mx-5">
        <div class="title font-weight-bold mb-3 mt-7">
          Kenntnisse &amp; Fähigkeiten
        </div>

        <ul class="portfolio__list body-1">
          <li class="portfolio__list-item">
            <strong>Architektonische Kompetenz:</strong>
            BIM-basierte Planung, nachhaltiges Bauen, HOAI Lph 1–8,
            Wettbewerbsplanung, Bauleitung
          </li>

          <li class="portfolio__list-item">
            <strong>Projektmanagement:</strong>
            Strukturierte Koordination, Termin- und Qualitätskontrolle,
            Bauüberwachung
          </li>

          <li class="portfolio__list-item">
            <strong>Persönliche Stärken:</strong>
            Zielorientierte Arbeitsweise, hohe Belastbarkeit unter Zeitdruck,
            Teamführung, interdisziplinäre Kommunikation, souveräne Präsentationen
            und praxisorientierte Problemlösung
          </li>
        </ul>
        </div>

  </v-row>

    <div v-if="!$vuetify.breakpoint.smAndDown" class="d-flex justify-center mt-6 mb-n6 ">
          <v-btn
            class="align-self-end mx-auto d-block"
            fab
            outlined
            color="grey"
            @click="$vuetify.goTo('#prejekte')"
          >
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>
    </div>

</v-col>


      <!-- PROJEKTY – 1. rząd (po 2 obok siebie) -->
      <v-col ref="section1" id="prejekte" cols="12" md="10" class="mb-8 " >
<!--       <div class="title mb-6"> Projekte </div> -->
        <v-row  >

          <!-- Projekt 1: Rappelkiste -->
          <v-col cols="12" md="6" class="mb-6" @click.prevent="projektNr = 1, showDialog = true">
            <v-card class="portfolio__project rounded-xl" outlined style="cursor : pointer">
              <v-card-text>
                <!-- nagłówek + krótki meta tekst -->
                <div class="d-flex justify-space-between align-start mb-3">
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">
                      Kindertagesstätte Rappelkiste
                    </div>
                    <div class="subtitle-2 grey--text">
                      Herbert-Tschäpe-Str. 2–4, Berlin-Lichtenberg
                    </div>
                  </div>
                  <div>
                  <v-chip label outlined>Umbau und Erweiterung</v-chip>
                  </div>
                </div>

                <!-- proporcje: 5/7 – więcej obrazu niż tekstu -->
                <v-row dense class="mb-3">
                  <v-col cols="12" md="5">

                    <p class="body-2 mb-1">

                      <strong>Bauherr:</strong> Medi-Sport e.V.
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Baukosten:</strong> 2,8 Mio €
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Bauzeit:</strong> 2019–2020
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Umfang:</strong> NGF 1.042 m², BRI 5.257 m³
                    </p>
                    <p class="body-2 mb-0">
                      <strong>Meine Tätigkeit:</strong> LPH 3–8<br>
                      <strong>Software:</strong> MicroStation, Orca,
                      ArchiCAD, SketchUp
                    </p>
                  </v-col>

                  <v-col cols="12" md="7">
                    <v-img
                      src="images/projekt1_1xs.png"
                      class="portfolio__img-main mb-2"
                      :aspect-ratio="4/3"
                      transition="scale-transition"
                    />
                  </v-col>
                </v-row>

                <!-- opis + miniatury: opis węższy, obrazki szerokie -->
                <v-row dense>
                  <v-col cols="12">
                    <p class="body-2 portfolio__text-small mb-2" :class="$vuetify.breakpoint.xsOnly ? 'text-justify' : 'text-left'">
                      Leistung: Um- und Ausbau bestehender Gebäudeteile, Aufstockung
                      des Hintergebäudes in Holzbauweise, Neubau eines Verbindungsgangs.
                      Helles Eingangsfoyer über zwei Etagen, Mehrzweckhalle im Erdgeschoss
                      durch Einbeziehung des zuvor ungenutzten Innenhofes.
                      Extensive Dachbegrünung unterstützt das Regenwassermanagement
                      und schützt vor sommerlicher Hitze. Erweiterung um 60 Kitaplätze,
                      Bauen bei laufendem Betrieb.
                    </p>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Projekt 2: JUKS -->
          <v-col cols="12" md="6" class="mb-6" @click.prevent="projektNr = 2, showDialog = true">
            <v-card class="portfolio__project rounded-xl" outlined style="cursor : pointer">
              <v-card-text>
                <div class="d-flex justify-space-between align-start mb-3">
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">
                      Jugendkunstschule JUKS
                    </div>
                    <div class="subtitle-2 grey--text">
                      Demminer Str. 4, Berlin-Hohenschönhausen
                    </div>
                  </div>
                  <div>
                  <v-chip label outlined>Umbau und Sanierung</v-chip>
                  </div>
                </div>

                <v-row dense class="mb-3">
                  <v-col cols="12" md="5">
                    <p class="body-2 mb-1">
                      <strong>Bauherr:</strong> Artki e.V.
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Baukosten:</strong> 1,5 Mio €
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Bauzeit:</strong> 2017–2018
                    </p>
                    <p class="body-2 mb-1">
                      <strong>Umfang:</strong> NGF 1.520 m², BRI 5.261 m³
                    </p>
                    <p class="body-2 mb-0">
                      <strong>Meine Tätigkeit:</strong> LPH 1–9<br>
                      <strong>Software:</strong> MicroStation, Orca,
                      MS Projekt, SketchUp
                    </p>
                  </v-col>

                  <v-col cols="12" md="7">
                    <v-img
                      src="images/projekt2xs.png"
                      class="portfolio__img-main"
                      :aspect-ratio="4/3"
                      transition="scale-transition"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <p class="body-2 portfolio__text-small" :class="$vuetify.breakpoint.xsOnly ? 'text-justify' : 'text-left'">
                      Leistung: Energetische Sanierung und barrierefreier Umbau einer
                      Plattenbau-Kunstschule im laufenden Betrieb. Einladende Umgestaltung
                      und Öffnung des Eingangsbereichs mit Luftraum, Schaffung
                      großzügiger und flexibler Grundrisse, Erweiterung mit
                      zusätzlichen Werkstätten im Keller sowie neuer Café- und
                      Ausstellungsbereich mit Terrasse zum Innenhof.
                      <br/>
                      <br/>

                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </v-col>

      <!-- Projekt 3 + KIDT – więcej obrazu niż tekstu -->
      <v-col cols="12" md="10" class="mb-4" @click.prevent="projektNr = 3, showDialog = true">
        <v-card class="portfolio__project rounded-xl" outlined style="cursor : pointer">
          <v-card-text>
            <!-- duże zdjęcie projekt4 jako tło sekcji -->
<!--            <v-row dense class="mb-4">
              <v-col cols="12">
                <v-img
                  src="images/projekt4.jpg"
                  class="portfolio__img-main"
                  transition="scale-transition"
                  contain
                />
              </v-col>
            </v-row>-->

            <v-row dense>
              <v-col cols="12" md="4">
                <p class="body-2 mb-1">
                  <strong>Ambulante Therapieeinrichtung KIDT</strong><br>
                  Demminer Str. 6, Berlin-Hohenschönhausen
                </p>
<!--                 <br/> -->
<!--                 <p class="body-2 my-3 "> -->
                  <v-chip label outlined class="my-4">Umbau und Sanierung</v-chip>
<!--                 </p> -->
<!--                 <br/> -->
                <p class="body-2 my-3 ">
                  <strong>Bauherr:</strong> K.I.D.T. gGmbH
                </p>
                <p class="body-2 mb-1">
                  <strong>Baukosten:</strong> 0,5 Mio €<br>
                  <strong>Bauzeit:</strong> 2022
                </p>
                <p class="body-2 mb-1">
                  <strong>Umfang:</strong> BGF 1.156 m², BRI 3.280 m³
                </p>
                <p class="body-2 mb-0">
                  <strong>Meine Tätigkeit:</strong> LPH 1–9<br>
                  <strong>Software:</strong> MicroStation, Orca, MS Projekt
                </p>
              </v-col>

              <v-col cols="6" md="4">
                <v-img
                  src="images/projekt5.png"
                  class="portfolio__img-main mb-2 mr-1"
                  :aspect-ratio="4/3"
                  transition="scale-transition"
                />
              </v-col>
              <v-col cols="6" md="4">
                <v-img
                  src="images/projekt5_1.png"
                  class="portfolio__img-main ml-1"
                  :aspect-ratio="4/3"
                  transition="scale-transition"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>



    <v-col cols="12" md="10" class="mb-8 mt-2">
    <div class="title mb-6"> Altbausanierung </div>
    <v-row >

 <!-- Waldemarstraße 81 -->
    <v-col cols="12" md="6" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <!-- Tytuł + lokalizacja -->
          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Wohnhaus Waldemarstraße 81
            </div>
            <div class="subtitle-2 grey--text">
              Berlin Kreuzberg
            </div>
          </div>

          <v-row dense class="mb-3">
            <!-- Tekst -->
            <v-col cols="12" md="5" >
              <p class="body-2 mb-1" >
                <strong>Leistung:</strong><br>
                Dachausbau und -neubau eines denkmalgeschützten Gebäudes (1856),
                bewohnt von einer Wohngemeinschaft. Ergänzt durch eine sensible
                Fassadensanierung mit historischer Wandmalerei.
              </p>
              <br/>
              <p class="body-2 mb-1">
                <strong>Bauherr:</strong> Genossenschaft Luisenstadt
              </p>
              <p class="body-2 mb-1">
                <strong>Baukosten:</strong> ca. 600.000 EUR
              </p>
              <p class="body-2 mb-1">
                <strong>Bauzeit:</strong> 2018–2019
              </p>
              <p class="body-2 mb-0">
                <strong>Umfang:</strong> BRI 546 m³<br>
                <strong>Meine Tätigkeit:</strong> LPH 1–9
              </p>
              <br/>
            </v-col>

            <!-- Zdjęcie -->
            <v-col cols="12" md="7">
              <v-img
                src="images/projekt8.png"
                class="portfolio__img-main"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>

<!-- Projekt: Legiendamm 36 -->
<v-col cols="12" md="6" class="mb-6">
  <v-card class="portfolio__project rounded-xl" outlined>
    <v-card-text>

      <!-- Tytuł + lokalizacja -->
      <div class="mb-3">
        <div class="text-subtitle-1 font-weight-bold">
          Wohnhaus Legiendamm 36
        </div>
        <div class="subtitle-2 grey--text">
          Berlin Kreuzberg
        </div>
      </div>

      <v-row dense class="mb-3">
        <v-col cols="12" md="5">
          <p class="body-2 mb-1">
            <strong>Leistung:</strong><br>
            Dachausbau und -neubau eines Gründerzeitgebäudes (1870), Vorderhaus &
            Seitenflügel. Einrichtung einer 5-Zimmer-Wohnung mit großer Terrasse.
            Fenstersanierung, Schwamm- und Fassadensanierung, Stuckfassade,
            Balkonanbauten sowie Innenraumsanierungen bestehender Wohneinheiten.
          </p>

          <p class="body-2 mb-1">
            <strong>Bauherr:</strong> Private Eigentümerin
          </p>
          <p class="body-2 mb-1">
            <strong>Baukosten:</strong> ca. 600.000 EUR
          </p>
          <p class="body-2 mb-1">
            <strong>Bauzeit:</strong> 2019–2020
          </p>
          <p class="body-2 mb-1">
            <strong>Umfang:</strong> BRI 958 m³
          </p>
          <p class="body-2 mb-0">
            <strong>Meine Tätigkeit:</strong> LPH 1–8
          </p>
        </v-col>

        <v-col cols="12" md="7">
          <v-img
            src="images/projekt7.png"
            class="portfolio__img-main"
            :aspect-ratio="4/3"
            transition="scale-transition"
          />
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</v-col>


        </v-row>
    </v-col>

<v-col cols="12" md="10" class="mb-8 ">
  <v-row dense>

      <v-col cols="12" md="12" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Wohnhaus Curtiusstraße 19
            </div>
            <div class="subtitle-2 grey--text">
              Berlin-Lichterfelde
            </div>
          </div>

          <v-row dense class="mb-3">
            <!-- Tekst -->
            <v-col cols="12" md="5">
              <p class="body-2 mb-1">
                <strong>Leistung:</strong><br>
                Instandsetzung und energetische Modernisierung einer repräsentativen
                Jugendstilvilla. Erweiterung der Balkonanlagen unter
                denkmalpflegerischen Vorgaben.
              </p>
              <br/>
              <p class="body-2 mb-1">
                <strong>Bauherr:</strong> Private Eigentümer
              </p>
              <p class="body-2 mb-1">
                <strong>Baukosten:</strong> ca. 900.000 EUR
              </p>
              <p class="body-2 mb-1">
                <strong>Bauzeit:</strong> 2018–2019
              </p>
              <p class="body-2 mb-1">
                <strong>Umfang:</strong> BRI 4.860 m³
              </p>
              <p class="body-2 mb-0">
                <strong>Meine Tätigkeit:</strong> LPH 1–9
              </p>
            </v-col>

            <!-- Zdjęcie -->
            <v-col cols="12" md="7" class="d-flex">
              <v-img
                src="images/projekt9_1.png"
                class="portfolio__img-main mr-5"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
              <v-img
                src="images/projekt9_2.png"
                class="portfolio__img-main"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>

  </v-row>
</v-col>

<v-col cols="12" md="10" class="">
<v-row >
<!-- Projekt: Wühlischstr. 56 -->
<v-col cols="12" md="6" class="mb-6">
  <v-card class="portfolio__project rounded-xl" outlined>
    <v-card-text>

      <!-- Tytuł + lokalizacja -->
      <div class="mb-3">
        <div class="text-subtitle-1 font-weight-bold">
          Wohnhaus Wühlischstr. 56
        </div>
        <div class="subtitle-2 grey--text">
          Berlin Friedrichshain
        </div>
      </div>

      <!-- Teksty + parametry (po lewej) + obrazek (po prawej) -->
      <v-row dense class="mb-3">
        <v-col cols="12" md="5">
          <p class="body-2 mb-1">
            <strong>Leistung:</strong><br>
            Dachausbau eines Alt-Berliner Wohnhauses (Vorderhaus, 2 Seitenflügel,
            Quergebäude)
          </p>
          <br/>
          <p class="body-2 mb-1">
            <strong>Bauherr:</strong> Privater Eigentümer
          </p>
          <p class="body-2 mb-1">
            <strong>Baukosten:</strong> ca. 700.000 EUR
          </p>
          <p class="body-2 mb-1">
            <strong>Bauzeit:</strong> 2016–2017
          </p>
          <p class="body-2 mb-0">
            <strong>Meine Tätigkeit:</strong> LPH 3–8
          </p>
          <br/>

          <br/>
        </v-col>

        <v-col cols="12" md="7">
          <v-img
            src="images/projekt6.png"
            class="portfolio__img-main"
            :aspect-ratio="4/3"
            transition="scale-transition"
          />
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</v-col>


    <!-- Curtiusstraße 19 -->
    <v-col cols="12" md="6" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <!-- Tytuł + lokalizacja -->
          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Wohnhaus Provinzstraße 93
            </div>
            <div class="subtitle-2 grey--text">
              Berlin Reinickendorf
            </div>
          </div>

          <v-row dense class="">
            <!-- Tekst po lewej (5 kolumn) -->
            <v-col cols="12" md="5">
              <p class="body-2 mb-1">
                <strong>Leistung:</strong><br>
                Dachneubau und -ausbau eines Altberliner Wohnhauses aus dem Jahr 1910
                (Vorderhaus & Seitenflügel). Einrichtung von zwei Wohnungen
                im zuvor unausgebauten Dachboden.
              </p>
              <p class="body-2 mb-1">
                <strong>Bauherr:</strong> Meilicke Provinzstr. GbR
              </p>
              <p class="body-2 mb-1">
                <strong>Baukosten:</strong> ca. 1.100.000 EUR
              </p>
              <p class="body-2 mb-1">
                <strong>Bauzeit:</strong> 2022–2023
              </p>
              <p class="body-2 mb-0">
                <strong>Meine Tätigkeit:</strong> LPH 4–9
              </p>
            </v-col>

            <!-- Zdjęcie po prawej (7 kolumn) -->
            <v-col cols="12" md="7">
              <v-img
                src="images/projekt10.jpg"
                class="portfolio__img-main"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>




  </v-row>
</v-col>







<v-col cols="12" md="10" class="mb-8 ">

<div class="title mb-5"> Weitere Projekte </div>

<v-row dense>

<!-- PROJEKT 12 -->
<v-col cols="12" md="12" class="mb-8">
  <v-row dense>
    <v-col cols="12" md="12" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <!-- Tytuł + lokalizacja -->
          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Piastow Office Center
            </div>
            <div class="subtitle-2 grey--text">
              Stettin (Szczecin, Polen)
            </div>
          </div>

          <v-row dense class="mb-3">
            <!-- Tekst -->
            <v-col cols="12" md="5">
              <p class="body-2 mb-1">
                <strong>Leistung:</strong><br>
                Büro- und Dienstleistungsensemble mit drei Bürogebäuden
                sowie Flächen für Dienstleistung und Handel.
              </p>
              <p class="body-2 mb-1">
                <strong>Realisierung:</strong> 2012–2015
              </p>
              <p class="body-2 mb-1">
                <strong>NGF:</strong> 20.000 m²
              </p>
              <p class="body-2 mb-0">
                <strong>Bearbeitet mit:</strong> Revit, AutoCAD, InDesign
              </p>
            </v-col>

            <!-- Zdjęcia – 2-elementowy collage -->
            <v-col cols="12" md="7">
              <v-row dense>
                <v-col cols="12" class="mb-2 d-flex ">
                  <v-img
                    src="images/projekt12_1xs.png"
                    class="portfolio__img-main mr-5"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
          <!--      </v-col>
                <v-col cols="12">-->
                  <v-img
                    src="images/projekt12_2xs.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-col>


<v-col cols="12"  class="mb-8 ">
  <v-row >
  <!-- PROJEKT 13 -->
    <v-col cols="12" md="6" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <!-- Tytuł + lokalizacja -->
          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Mehrfamilienhaussiedlung in Stettin
            </div>
            <div class="subtitle-2 grey--text">
              Stettin (Szczecin, Polen)
            </div>
          </div>

          <v-row  class="mb-3">
            <!-- Tekst -->
            <v-col cols="12" md="5">
              <p class="body-2 mb-1">
                <strong>Leistung:</strong><br>
                Mehrfamilienhaussiedlung mit fünf Wohngebäuden,
                flankiert von Dienstleistungs- und Handelsnutzungen.
              </p>
              <p class="body-2 mb-1">
                <strong>Planung:</strong> 2011
              </p>
              <p class="body-2 mb-1">
                <strong>BGF:</strong> 68.700 m²
              </p>
              <p class="body-2 mb-0">
                <strong>Bearbeitet mit:</strong> ArchiCAD, Artlantis
              </p>
            </v-col>

            <!-- Zdjęcia – collage 1 + 2 -->
            <v-col cols="12" md="7">
              <v-row dense >
                <v-col cols="12" class="mb-2">
                  <v-img
                    src="images/projekt13_1.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
                <v-col cols="6">
                  <v-img
                    src="images/projekt13_2.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
                <v-col cols="6">
                  <v-img
                    src="images/projekt13_3.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>

<!-- PROJEKT 11 -->
    <v-col cols="12" md="6" class="mb-6">
      <v-card class="portfolio__project rounded-xl" outlined>
        <v-card-text>

          <!-- Tytuł + lokalizacja -->
          <div class="mb-3">
            <div class="text-subtitle-1 font-weight-bold">
              Einfamilienhaussiedlung in Stettin
            </div>
            <div class="subtitle-2 grey--text">
              Stettin (Szczecin, Polen)
            </div>
          </div>

          <!-- Tekst + parametry + zdjęcia -->
          <v-row  class="mb-3">
            <!-- Tekst -->
            <v-col cols="12" md="5">
              <p class="body-2 mb-1">
                <strong>Leistung:</strong><br>
                Planung einer Einfamilienhaussiedlung mit
                83 Einfamilienhäusern und 3 Mehrfamilienhäusern.
              </p>
              <p class="body-2 mb-1">
                <strong>Realisierung:</strong> 2011–2012
              </p>
              <p class="body-2 mb-1">
                <strong>Grundfläche:</strong> 97.100 m²
              </p>
              <p class="body-2 mb-0">
                <strong>Bearbeitet mit:</strong> ArchiCAD, Artlantis
              </p>
            </v-col>

            <!-- Zdjęcia – collage -->
            <v-col cols="12" md="7">
              <v-row dense>
                <v-col cols="12">
                  <v-img
                    src="images/projekt11_1.png"
                    class="portfolio__img-main mb-2"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
                <v-col cols="6">
                  <v-img
                    src="images/projekt11_2.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
                <v-col cols="6">
                  <v-img
                    src="images/projekt11_3.png"
                    class="portfolio__img-main"
                    :aspect-ratio="4/3"
                    transition="scale-transition"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>



  </v-row>
</v-col>



<!--<v-col cols="12" md="10" class="mb-8">
  <v-row dense>-->

<!--  </v-row>
</v-col>-->

<!-- PROJEKT 14 -->

<!-- PROJEKT 14 – jeden „odjechany” element -->
<v-col cols="12" md="12" class="mb-8">
  <v-card class="portfolio__project rounded-xl " outlined>
    <v-card-text>

      <!-- Nagłówek -->
      <div class="mb-6">
        <div class="text-h6 font-weight-bold">See Museum in Stettin </div>
        <div class="subtitle-2 grey--text">Büroräume, Ausstellungsräume,  Terrasse, Fußgängerbrücke</div>
      </div>

      <!-- Główny układ 3-kolumnowy -->
      <v-row dense class="align-start project14-grid">

        <!-- KOLUMNA 1 – opis główny -->
        <v-col cols="12" md="4">
          <p class="body-2 mb-3">
            <strong>Wettbewerb:</strong> 2011<br>
            <strong>BGF:</strong> 4.298,8 m²<br>
            <strong>Bearbeitet mit:</strong> AutoCAD, InDesign
          </p>

          <p class="body-2 mb-3">
            <strong>Nutzungsschwerpunkte:</strong><br>
            Zwei Hauptausstellungsräume, Bibliothek, Showroom,
            Café, Dachterrasse sowie eine Fußgängerbrücke.
          </p>

          <p class="body-2">
            <strong>Urbankonzept:</strong><br>
            Rampe als zentrales Element zur Verbindung von
            Terrasse und Innenhof, mit Rundgang durch die
            Ausstellung im Inneren.
          </p>
        </v-col>

        <!-- KOLUMNA 2 – collage: główne wizualizacje -->
        <v-col cols="12" md="8" class="d-flex">
          <v-img
            src="images/projekt14_1.png"
            class="portfolio__img-main mb-3 mr-5"
            :aspect-ratio="4/3"
            transition="scale-transition"
          />
          <v-img
            src="images/projekt14_2.png"
            class="portfolio__img-main mb-3"
            :aspect-ratio="4/3"
            transition="scale-transition"
          />

        </v-col>

        <v-col cols="12" md="12" class="d-flex">
          <v-img
            src="images/projekt14_11.png"
            class="portfolio__img-main mb-3 mr-5"
            transition="scale-transition"
          />


        </v-col>

<!--          <p class="body-2 mb-3">
            <strong>Fassade:</strong><br>
            Vertikale Paneelstruktur mit LED-Licht, angelehnt
            an eine wellende Spiegelfläche.
          </p>-->
        <!-- KOLUMNA 3 – collage fasady -->
<!--         <v-col cols="12" md="4"> -->


<!--           <v-row dense> -->
<!--            <v-col cols="12" class="mb-3">
              <v-img
                src="images/projekt14_5.png"
                class="portfolio__img-main"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
            </v-col>-->
<!--
            <v-col cols="6" v-for="img in ['6','7','8','9','10','11']" :key="img">
              <v-img
                :src="`images/projekt14_${img}.png`"
                class="portfolio__img-main mb-3"
                :aspect-ratio="4/3"
                transition="scale-transition"
              />
            </v-col>-->
<!--           </v-row> -->
<!--         </v-col> -->

      </v-row>
    </v-card-text>
  </v-card>
</v-col>

<!-- Nagłówek -->
  <div  ref="section2" class="title font-weight-bold mb-0 ml-1 mt-2">
    Projekterfahrung – Zusammenfassung
  </div>

  <!-- ELEGANCKA KARTA -->
  <div class="portfolio-card elevation-soft pa-5 mb-10">
    <ul class="portfolio-list-modern">
      <li>
        Entwurfs-, Genehmigungs- und Ausführungsplanung komplexer
        Umbauten und Erweiterungen öffentlicher Bildungs- und
        Sozialeinrichtungen im Berliner Raum – stets mit Fokus auf
        nachhaltigen Baukonzepten.
      </li>

      <li>
        Verantwortlich für alle Leistungsphasen 1–8 der HOAI, inklusive
        Baustellenbetreuung, Termin- und Kostenkontrolle sowie
        Ausschreibungen (VOB).
      </li>

      <li>
        Kreative, funktionale Lösungen für komplexe Bestands- und
        Neubauprojekte; Verbesserung der Bauqualität durch optimierte
        Detailplanung.
      </li>

      <li>
        Schwerpunkt auf Nachhaltigkeit, energetischer Sanierung und
        ressourcenschonenden Materialien (Holzbauweise,
        energieeffiziente Standards).
      </li>

      <li>
        Einsatz von BIM-Methoden zur Optimierung von Planung,
        Kommunikation und Koordination aller Projektbeteiligten.
      </li>

      <li>
        Effiziente Abstimmung mit Bauherren, Behörden, Fachplanern
        und Bauunternehmen — besonders bei sensiblen
        Bestandsprojekten.
      </li>

      <li>
        Projektleitung von Wohnbauvorhaben und anspruchsvollen
        Umbauprojekten.
      </li>
    </ul>
  </div>


</v-row>
<div id="kontakt">
  <w-footer
    class="mb-n13"
    @impressum="projektNr = 100, showDialog = true"
    @datenschutz="projektNr = 0, showDialog = true"
  />
</div>

<!--
<v-footer
  id="kontakt"
  padless
  class="portfolio-footer py-6 px-4"
>
  <v-container>
    <v-row align="center" justify="space-between">

      <v-col cols="12" md="6" class="mb-4 mb-md-0">
        <div class="text-h6 font-weight-bold">Monika Moskaluniec</div>
        <div class="mt-1">
          Architektin · Nachhaltiges Bauen · BIM
        </div>
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="d-flex flex-column flex-sm-row align-center justify-end"
      >
        <div class="d-flex align-center mr-sm-6 mb-2 mb-sm-0">
          <v-icon small class="mr-2">mdi-email</v-icon>
          <a
            href="mailto:m.moskaluniec@gmail.com"
            class="portfolio-footer__link"
          >
            m.moskaluniec@gmail.com
          </a>
        </div>

        <div class="d-flex align-center">
          <v-icon small class="mr-2">mdi-linkedin</v-icon>
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            class="portfolio-footer__link"
          >
            LinkedIn
          </a>
        </div>
      </v-col>

    </v-row>
  </v-container>
</v-footer>-->

</v-col>
</v-row>
  </v-container>
</template>

<script>
export default {
  name: 'mainPage',
  components: {
    'w-dialog' : () => import('./dialogs'),
    'w-footer' : () => import('./footer')

  },

  props : {
    // tab : {
    //   type : Number,
    //   default : 0
    //   }
    },

  watch: {
    // tab(newVal) {
    //   this.scrollToSection(newVal)
    // }
  },

  data: () => ({
    scrolling : false,
    scrollingTimeout : null,
    tab : null,
    clicked : false,
    clickedInterval : null,
    showDialog : false,
    projektNr : 0
  }),

methods: {

onScroll() {
    // this.scrolling = true
    // clearTimeout(this.scrollingTimeout)
    // this.scrollingTimeout = null
    // this.scrollingTimeout = setTimeout(()=>{
      // this.scrolling = false
    // },1000)
  if (!this.clicked) {
  const scrollY = window.pageYOffset || document.documentElement.scrollTop

  if (!this.scrollRanges) return

  let active = this.tab

  this.scrollRanges.forEach((r, i) => {
    if (scrollY >= r.start && scrollY < r.end) {
      active = i
    }
  })

  // aktualizacja taba tylko jeśli zaszła zmiana
  if (active !== this.tab) {
    this.tab = active
  this.$emit('update:tab', active)
  }
  }

},

  handleScroll() {
        // this.scrollOn == true
      if (this.clicked == false ) {
      // console.log(window.scrollY)
      if (this.$vuetify.breakpoint.mdAndDown) {
        if ( window.scrollY < 1120 ) {
              this.$emit('update:tab', 0)
          }
          else if (window.scrollY > 1120 && window.scrollY < 9550 ) {
            this.$emit('update:tab', 1)
            }
            else if (window.scrollY > 9550 ) {
              this.$emit('update:tab', 2)
              }
      } else {
        if (window.scrollY > 50 && window.scrollY < 600 ) {
              this.$emit('update:tab', 0)
          }
          else if (window.scrollY > 600 && window.scrollY < 4225 ) {
            this.$emit('update:tab', 1)
            }
            else if (window.scrollY > 4225 ) {
              this.$emit('update:tab', 2)
              }
        }
      }
    },

  calculateScrollRanges() {
    const s1 = this.$refs.section0
    const s2 = this.$refs.section1
    const s3 = this.$refs.section2

    this.scrollRanges = [
      {
        start: s1.offsetTop,
        end: s1.offsetTop + s1.offsetHeight
      },
      {
        start: s2.offsetTop,
        end: s2.offsetTop + s2.offsetHeight
      },
      {
        start: s3.offsetTop,
        end: Infinity   // ostatnia może ciągnąć się do końca
      }
    ]
  },

    scrollToSection(index) {
      this.clicked = true
      clearTimeout( this.clickedInterval)

    // if (!this.scrolling){
        if (index == 1) {
        // const el = this.$refs[`section${index}`]
        // if (!el) return
        // const offset = 50  // ile px od góry ma zostać
        // const top = el.offsetTop - offset
        // smooth scroll
          // const el = this.$refs.section1
          // const offset = 20
        // el.scrollIntoView({
        //   top: el.offsetTop - offset,
        //   behavior: "smooth",
        //   block: "start"
        // })
          // window.scrollTo({
          //           top: el.offsetTop - offset,
          //           behavior: 'smooth'
          //         })
          this.$vuetify.goTo('#prejekte')
          }
          else if (index == 0){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  })
            }
                else if (index == 2){
                  // setTimeout(() => {
                    this.$vuetify.goTo('#kontakt')
                    // },500)
                  setTimeout(() => {
                    this.$vuetify.goTo('#kontakt')
                    },500)
                    // window.scrollTo({
                    //   top: document.documentElement.scrollHeight,
                    //   behavior: 'smooth'
                    // })
            }

        this.clickedInterval = setTimeout( () =>{
              this.clicked = false
            },1500)
              // }
        }

    },
mounted() {
  this.$nextTick( () => {
  this.calculateScrollRanges()
  // window.addEventListener('resize', this.calculateScrollRanges)
  })

},

};
</script>

<style>


.portfolio {
  background: #fafafa;
  font-family: 'Calibri', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', sans-serif;
}

.portfolio__logo {
  max-width: 220px;
}

.portfolio__lead {
  line-height: 1.7;
  max-width: 60rem;
}


.portfolio__portrait {
  max-width: 400px;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.portfolio__project {
  border-radius: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.portfolio__project:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.16);
}

.portfolio__img-main {
  border-radius: 12px;
  overflow: hidden;
}

.portfolio__img-thumb {
  border-radius: 10px;
  overflow: hidden;
}

.portfolio__text-small {
  line-height: 1.5;
  font-size: 0.9rem;
}

.portfolio-footer {
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}

.portfolio-footer__link {
  color: #1a1a1a;
  text-decoration: none;
  font-weight: 500;
}

.portfolio-footer__link:hover {
  text-decoration: underline;
}

</style>
